// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import {
  Accordion,
  Box,
  Flex,
  StarCircledIcon,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';
import { spacing } from '@iheartjane/reefer-emotion';

import { AddInfoPrompt } from '@jane/monolith/components/cart/pendingCartDrawer/cartDrawerSpecials/addInfoPrompt';
import { LoginProtected } from '@jane/monolith/components/cart/pendingCartDrawer/cartDrawerSpecials/loginProtected';

import styles from './customerLoyaltyPoints.module.css';

const BoxWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.colors.grays.white,
  borderRadius: '25px',
  border: `1px solid ${theme.colors.grays.light}`,
  ...spacing({
    p: 56,
    mt: 24,
    mb: 12,
  }),
}));

interface CustomerLoyaltyPointsGuestProps {
  isHeadless?: boolean;
  signedIn?: boolean;
  storeRewardLabel?: string | null;
}

export const CustomerLoyaltyPointsGuest = ({
  isHeadless,
  signedIn = false,
  storeRewardLabel,
}: CustomerLoyaltyPointsGuestProps) => {
  const isMobile = useMobileMediaQuery({});
  const rewardsTitle = `Use store ${
    storeRewardLabel ? storeRewardLabel : 'rewards'
  }`;

  if (isHeadless) {
    return (
      <BoxWrapper>
        <Typography
          variant="h2-semibold"
          branded
          mb={24}
          className={styles['title']}
        >
          {rewardsTitle}
        </Typography>
        {signedIn ? (
          <AddInfoPrompt rewardsLabel={storeRewardLabel} />
        ) : (
          <LoginProtected rewardsLabel={storeRewardLabel} isRewards />
        )}
      </BoxWrapper>
    );
  }

  return (
    <Accordion.Item id="store-rewards">
      <Accordion.Heading px={isMobile ? 24 : 40} py={20}>
        <Flex alignItems="center" justifyContent="space-between">
          <Flex alignItems="center">
            <div>
              <StarCircledIcon />
            </div>
            <Typography variant="body-semibold" ml={16}>
              {rewardsTitle}
            </Typography>
          </Flex>
          <Flex pl={16}>
            <Accordion.Indicator iconSize="md" />
          </Flex>
        </Flex>
      </Accordion.Heading>
      <Accordion.Content px={isMobile ? 24 : 40} destroyOnClose>
        <Box pl={40}>
          {signedIn ? (
            <AddInfoPrompt rewardsLabel={storeRewardLabel} />
          ) : (
            <LoginProtected rewardsLabel={storeRewardLabel} isRewards />
          )}
        </Box>
      </Accordion.Content>
    </Accordion.Item>
  );
};
